import { MapMarkerMultipleIcon } from './MapMarkerMultipleIcon';

/**
 * author: Austin Andrews
 * id 6283577D-6B31-4297-8747-4F466580E79A
 * name map-marker-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-multiple.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const LocationsIcon = MapMarkerMultipleIcon;
export default LocationsIcon